import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Intro from '../page/intro/intro.vue';
import IntroReady from '../page/intro/intro_ready.vue'
import IntroEnd from '../page/intro/intro_end.vue';
import IntroEv from '../page/intro/intro_ev.vue';
import Setting01 from '../page/setting/setting_01.vue';
import Setting02 from '../page/setting/setting_02.vue';
import Setting03 from '../page/setting/setting_03.vue';
import Setting04 from '../page/setting/setting_04.vue';
import TestStart from '../page/stare/test_start.vue';
import Part01 from '../page/stare/part_01.vue';
import Part02 from '../page/stare/part_02.vue';
import Part03 from '../page/stare/part_03.vue';
import Part04 from '../page/stare/part_04.vue';
import Part05 from '../page/stare/part_05.vue';
import Part06 from '../page/stare/part_06.vue';
import TestEnd from '../page/stare/test_end.vue';
import Pre_part01 from '../page/preview/part_01.vue';
import Pre_part02 from '../page/preview/part_02.vue';
import Pre_part03 from '../page/preview/part_03.vue';
import Pre_part04 from '../page/preview/part_04.vue';
import Pre_part05 from '../page/preview/part_05.vue';
import Pre_part06 from '../page/preview/part_06.vue';
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path:'/intro',
    name:'Intro',
    component: Intro,
  },
  {
    path: '/intro_ready/:sdate/:edate',
    name: 'IntroReady',
    component: IntroReady
  },
  {
    path: '/intro_end/:applicationDate',
    name: 'IntroEnd',
    component: IntroEnd
  },
  {
    path: '/intro_ev/:email',
    name: 'IntroEv',
    component: IntroEv
  },
  {
    path: '/setting01',
    name: 'Setting01',
    component: Setting01
  },
  {
    path: '/setting02',
    name: 'Setting02',
    component: Setting02
  },
  {
    path: '/setting03',
    name: 'Setting03',
    component: Setting03
  },
  {
    path: '/setting04',
    name: 'Setting04',
    component: Setting04
  },
  {
    path: '/test_start/:type',
    name: 'TestStart',
    component: TestStart
  },
  {
    path: '/test_end/:type',
    name: 'TestEnd',
    component: TestEnd
  },
  {
    path: '/part01/:type',
    name: 'part01',
    component: Part01
  },
  {
    path: '/part02/:type',
    name: 'part02',
    component: Part02
  },
  {
    path: '/part03/:type',
    name: 'part03',
    component: Part03
  },
  {
    path: '/part04/:type',
    name: 'part04',
    component: Part04
  },
  {
    path: '/part05/:type',
    name: 'part05',
    component: Part05
  },
  {
    path: '/part06/:type',
    name: 'part06',
    component: Part06
  },
  {
    path: '/preview/part_01/:module',
    name: 'Pre_part01',
    component: Pre_part01
  },
  {
    path: '/preview/part_02/:module',
    name: 'Pre_part02',
    component: Pre_part02
  },
  {
    path: '/preview/part_03/:module',
    name: 'Pre_part03',
    component: Pre_part03
  },
  {
    path: '/preview/part_04/:module',
    name: 'Pre_part04',
    component: Pre_part04
  },
  {
    path: '/preview/part_05/:module',
    name: 'Pre_part05',
    component: Pre_part05
  },
  {
    path: '/preview/part_06/:module',
    name: 'Pre_part06',
    component: Pre_part06
  }

  
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
